import React, { Component } from 'react';
import {
    Alert,
    Button,
    Col,
    Container,
    Form,
    Image,
    InputGroup,
    Row,
    Stack,
} from 'react-bootstrap';
import config from '../../Api/config';
import Swal from 'sweetalert2';
import $ from 'jquery';
import { getUrlVars } from '../../Api/common';
import BgImage from '../../Assets/Img/login_bg.png';
import Logo from '../../Assets/Img/logo.svg';
import { Eye, EyeOff } from 'lucide-react';
import LoadingComponent from '../LoadingComponent';
import { getSecureItem } from "../../utils/secureStorage";
class SetPwd extends Component {
    constructor() {
        super();
        this.state = {
            emailID: '',
            pwd: '',
            loginIP: '',
            loginBrowser: '',
            deviceType: '',
            userLocation: '',
            logIsp: '',
            ii: 0,
            actions: [],
            pLogo: '',
            input: {},
            errors: {},
            showpwd: false,
            loading: false,
            error: false,
        };

        this.handleChange = this.handleChange.bind(this);
        this.togglePwd = this.togglePwd.bind(this);
        this.submit = this.submit.bind(this);
        this.meow = this.meow.bind(this);
    }

    handleChange(event) {
        let input = this.state.input;
        input[event.target.name] = event.target.value;

        this.setState({
            input,
        });
    }

    togglePwd() {
        this.setState({ showpwd: !this.state.showpwd });
    }

    validate() {
        let input = this.state.input;
        let errors = {};
        let isValid = true;

        if (!input['password']) {
            isValid = false;
            errors['password'] = "Merci d'entrer votre mot de passe.";
        }
        if (!input['confirm_password']) {
            isValid = false;
            errors['confirm_password'] =
                'Merci de confirmer votre mot de passe.';
        }
        if (typeof input['password'] !== 'undefined') {
            if (input['password'].length < 8) {
                isValid = false;
                errors['password'] =
                    'Le mot de passe doit contenir au minimum 8 caractères, 1 majuscule, 1 minuscule, 1 symbole (@ / ? …)';
            } else if (
                !/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$%^&*!()_+{}\[\]:;<>,.?~\\-])/.test(
                    input['password']
                )
            ) {
                isValid = false;
                errors['password'] =
                    'Le mot de passe doit contenir au moins une minuscule, une majuscule, un caractère spécial et un chiffre.';
            }
        }
        if (
            typeof input['password'] !== 'undefined' &&
            typeof input['confirm_password'] !== 'undefined'
        ) {
            if (input['password'] !== input['confirm_password']) {
                isValid = false;
                errors['confirm_password'] =
                    'Les mots de passe ne correspondent pas.';
            }
        }

        this.setState({
            errors: errors,
        });

        return isValid;
    }

    Passwordurlexpiration() {
        let data1 = {
            encryptedPassword: getUrlVars()[0],
        };
        /////////////////
        let logourl = config.API_URL + '/profile/password/urlexpiration';

        /////////////////////
        // let logourl = API_URL + "/Products/add";
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                authorization: getSecureItem('token'),
            },
            body: JSON.stringify(data1),
        };
        fetch(logourl, requestOptions)
            .then((res) => res.text())
            .then((json) => {
                if (json == '1') {
                    $('.passwordlink').find('h4').html('');
                    $('.passwordlink').find('form').html('');
                    $('.backscreen').html('');
                    $('.messageappend').append(
                        "<h4 class='card-title mb-1'>Le lien que vous avez suivi a expiré.</h4>"
                    );
                    $('.backscreen').append(
                        "<a href='/forgotpassword'> <i data-feather='chevron-left'></i> Retour à l'écran d'oubli du mot de passe ? </a>"
                    );
                } else if (json == '2') {
                    $('.passwordlink').find('h4').html('');
                    $('.passwordlink').find('form').html('');
                    $('.messageappend').append(
                        "<h4 class='card-title mb-1'>Le code de cryptage n'existe pas. </h4>"
                    );
                }
            })
            .catch((e) => {
                Swal({
                    title: 'OOPS!',
                    text: 'json',
                    icon: 'warning',
                });
                console.log(e);
            });
    }

    componentDidMount() {
        if (getSecureItem('meow') != 'ok') {
            $('#overlay').show();
        }
        this.Passwordurlexpiration();
    }

    meow() {
        localStorage.setItem('meow', 'ok');
        $('#overlay').hide();
    }

    submit(e) {
        e.preventDefault();
        if (this.validate()) {
            console.log(this.state);
            let input = {};
            input['password'] = '';
            input['confirm_password'] = '';
            this.setState({ input: input });
        } else {
            return;
        }

        this.setState({ loading: true });

        Swal.fire({
            html: '<div><img src="https://miro.medium.com/max/875/1*CsJ05WEGfunYMLGfsT2sXA.gif" width="250" /></div>',
            title: 'Please wait',
            allowOutsideClick: false,
            showConfirmButton: false,
            willOpen: () => {
                Swal.showLoading();
            },
        });

        const params = new URLSearchParams(window.location.search);
        let email1 = getUrlVars()[0];
        let data1 = {
            emailId:
                email1 == undefined || email1 == '' ? params.get('e') : email1,
            newPassword: document.getElementById('cnewp').value,
        };
        let logourl = config.API_URL + '/profile/password/reset';
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                authorization: getSecureItem('token'),
            },
            body: JSON.stringify(data1),
        };
        fetch(logourl, requestOptions)
            .then((res) => res.text())
            .then((text) => {
                Swal.close();
                if (text == 'success') {
                    Swal.fire({
                        title: "C'est fait !",
                        text: 'Mot de passe défini avec succès',
                        icon: 'success',
                    }).then(() => {
                        this.componentDidMount();
                        localStorage.clear();
                        window.location.href = '/login';
                    });
                } else {
                    this.setState({ error: true, loading: false });
                    Swal.fire({
                        title: 'OOPS!',
                        text: 'json',
                        icon: 'warning',
                    });
                }
            })
            .catch((e) => {
                Swal.close();
                this.setState({ loading: false });
                console.log(e);
            });
    }

    render() {
        return (
            <Container fluid className="login_wrapper">
                <Row>
                    <Col
                        lg={8}
                        style={{ backgroundImage: `url(${BgImage})` }}
                        className="login_left_wrapper"
                    ></Col>
                    <Col lg={4} className="login_right_wrapper">
                        <div className="login_right_wrapper_inner">
                            <Stack gap={3}>
                                <div>
                                    <div className="login_logo">
                                        <Image src={Logo} />
                                    </div>
                                    <Form onSubmit={this.submit}>
                                        <h3>
                                            Définissez votre nouveau mot de
                                            passe 🔒
                                            <br />
                                            Bienvenue
                                        </h3>

                                        <Form.Group
                                            controlId="formPassword"
                                            className="mb-4"
                                        >
                                            <Form.Label>
                                                Nouveau mot de passe
                                            </Form.Label>
                                            <InputGroup>
                                                <Form.Control
                                                    type={
                                                        this.state.showpwd
                                                            ? 'text'
                                                            : 'password'
                                                    }
                                                    id="newp"
                                                    name="password"
                                                    value={
                                                        this.state.input
                                                            .password
                                                    }
                                                    onChange={this.handleChange}
                                                    placeholder="Votre nouveau mot de passe"
                                                    required
                                                />
                                                <InputGroup.Text
                                                    onClick={this.togglePwd}
                                                    style={{
                                                        cursor: 'pointer',
                                                    }}
                                                >
                                                    {this.state.showpwd ? (
                                                        <Eye />
                                                    ) : (
                                                        <EyeOff />
                                                    )}
                                                </InputGroup.Text>
                                            </InputGroup>
                                            {this.state.errors.password && (
                                                <Form.Text className="text-danger">
                                                    {this.state.errors.password}
                                                </Form.Text>
                                            )}
                                        </Form.Group>

                                        <Form.Group
                                            controlId="formConfirmPassword"
                                            className="mb-4"
                                        >
                                            <Form.Label>
                                                Confirmer le mot de passe
                                            </Form.Label>
                                            <InputGroup>
                                                <Form.Control
                                                    type={
                                                        this.state.showpwd
                                                            ? 'text'
                                                            : 'password'
                                                    }
                                                    id="cnewp"
                                                    name="confirm_password"
                                                    value={
                                                        this.state.input
                                                            .confirm_password
                                                    }
                                                    onChange={this.handleChange}
                                                    placeholder="Confirmez votre mot de passe"
                                                    required
                                                />
                                                <InputGroup.Text
                                                    onClick={this.togglePwd}
                                                    style={{
                                                        cursor: 'pointer',
                                                    }}
                                                >
                                                    {this.state.showpwd ? (
                                                        <Eye />
                                                    ) : (
                                                        <EyeOff />
                                                    )}
                                                </InputGroup.Text>
                                            </InputGroup>
                                            {this.state.errors
                                                .confirm_password && (
                                                <Form.Text className="text-danger">
                                                    {
                                                        this.state.errors
                                                            .confirm_password
                                                    }
                                                </Form.Text>
                                            )}
                                        </Form.Group>

                                        <Button
                                            variant="primary"
                                            type="submit"
                                            className="w-100"
                                        >
                                            Définir le mot de passe
                                        </Button>

                                        {this.state.error && (
                                            <Alert
                                                variant="danger"
                                                className="mt-3"
                                            >
                                                Une erreur s'est produite lors
                                                de la définition du mot de passe
                                            </Alert>
                                        )}
                                    </Form>

                                    <div className="d-flex justify-content-center mt-3">
                                        <Button variant="link" href="/login">
                                            Retour à l'écran de connexion
                                        </Button>
                                    </div>
                                </div>
                                <div className="copyright mt-auto text-center">
                                    © Sym Tech - 2026
                                </div>
                            </Stack>
                        </div>
                    </Col>
                </Row>
                <LoadingComponent loading={this.state.loading} />
            </Container>
        );
    }
}

export default SetPwd;
